import styled from "styled-components";

export const NewBlogWrapper = styled.div`
  width: 100%;
  background: #fff;
  min-height: 100vh;
  display: flex;
  align-items: center;
  flex-direction: column;
  padding-top: 40px;
`;
export const SuggestionWrapper = styled.div`
  height: 70vh;
  overflow-y: scroll;
  padding-top: 10px;
  margin-top: 20px;
  margin-right: 50px;
  padding: 10px;
  @media only screen and (max-width: 900px) {
    width: 100%;
  }
  &::-webkit-scrollbar {
    width: 5px;
    background: #f9f9fc;
    border-radius: 5px;
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 5px;
    background: #4a60f4;
  }
`;
export const TranscriptionWrapper = styled.div`
  background: #fff;
  min-height: 100vh;
 
  .blog-container {
    @media (min-width: 1200px) {
      width: 1280px;
    }
  }
  .steps-content {
    padding: 40px 20px;
    background: #fff;
    margin: 0 !important;
  }
  .steps-content2 {
    margin: 0 !important;
    padding: 20px;
    padding-bottom: 0;
    background: #fff;
    border-radius: 0px;
  }
  .editorContent {
    font-family: Roboto;
    font-style: normal;
    font-weight: 400;
    width: 100%;
    margin-left: 0%;
    margin-top: 10px;
    padding: 10px;
    height: 73vh;
    overflow-y: scroll;
    &::-webkit-scrollbar {
      width: 5px;
      background: #f9f9fc;
      border-radius: 5px;
    }

    &::-webkit-scrollbar-thumb {
      border-radius: 5px;
      background: #4a60f4;
    }
  }
  .editorWrapper {
    height: 80vh;
  }
  @media only screen and (max-width: 900px) {
    .editorWrapper {
      height: 80vh;
      margin-top:150px;
    }
  }

  .blockStyle {
    color: #7c82a7;
  }
  .transform {
    color: #7c82a7;
    font-family: Roboto;
    font-style: normal;
    font-weight: 400;
  }
  .contentWrapper {
    overflow: hidden;
    display:flex;
    align-items:baseline;
  }
  @media only screen and (max-width: 900px) {
    .contentWrapper {
      display: flex;
      row-gap:50px;
      flex-direction: column;
      .suggestion-wrapper-container,
      .editor-container {
        min-width: 100%;
      }
    }
  }
  .switch {
    display: flex;
    float: right;
    align-items: center;
    margin-top: 16px;
    margin-right: 5px;
  }
  .switch > label {
    color: #7c82a7;
    font-family: Roboto;
    margin-left: 10px;
    margin-right: 10px;
    font-size: 14px;
  }
  .editorToolbar {
    display: none;
    width: ${(props) => props.toolbarWidth}px;
    .rdw-option-wrapper,
    .rdw-dropdown-wrapper {
      border: none;
      color: #2c304b;
    }
    .rdw-option-wrapper > img {
    }
    .rdw-option-wrapper:hover,
    .rdw-dropdown-wrapper:hover {
      box-shadow: none;
    }
    .rdw-option-active {
      color: #4a60f4 !important;
      box-shadow: none;
    }
    .rdw-dropdown-selectedtext {
      color: #2c304b;
    }
    .rdw-history-wrapper,
    .rdw-inline-wrapper,
    .rdw-colorpicker-wrapper,
    .rdw-block-wrapper,
    .rdw-list-wrapper,
    .rdw-text-align-wrapper,
    .rdw-link-wrapper,
    .rdw-remove-wrapper {
      border-right: 1px solid #d3d6eb;
    }
  }
  .actionWrapper {
    width: 100%;
    margin-top: -48px;
    .wordsSelection {
      color: #babed8;
      padding-left: 30px;
    }
  }
  .action {
    display: flex;
    justify-content: flex-end;
    padding-right: 3%;
  }
`;
export const ResultWrapper = styled.div`
  font-family: Lato;
  font-style: normal;
  border: 0.5px solid #f8f8f8;
  width: 97%;
  height: 60vh;
  margin-top: 55px;
  box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.2);
  overflow-y: scroll;
  padding: 20px;
  font-size: 14px;
  line-height: 23px;
`;

export const StepsWrapperOuter = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 50px 0;
  @media (max-width: 786px) {
    display: flex;
    flex-direction: column;
  }
`;
export const KeyToolTipSpan1 = styled.span`
  font-family: Lato;
  font-size: 14px;
  color: #7c82a7;
  font-weight: bold;
`;
export const KeyToolTipSpan2 = styled.span`
  font-family: Lato;
  font-size: 12px;
  color: #7c82a7;
`;
export const PLayerContainer = styled.div`
  padding: 0 15px;
  margin: 0 auto;
  @media (min-width: 576px) {
    width: 100%;
  }
  @media (min-width: 768px) {
    width: 100%;
  }
  @media (min-width: 992px) {
    width: 980px;
  }
  @media (min-width: 1200px) {
    width: 1180px;
  }
  @media (min-width: 1600px) {
    width: 1580px;
  }
  @media (min-width: 1900px) {
    width: 1680px;
  }
  &.no-padding {
    padding: 0px;
  }
  .no-verticle-padding {
    padding-left: 0px;
    padding-right: 0px;
  }
  .arrows-wrapper {
    display: flex;
    align-items: center;
    button {
      border: none;
    }
  }
`;
export const StepsWrapperInner = styled.div`
  // max-width: 500px;
  .ant-steps-item {
    .ant-steps-item-container {
      display: flex;
      align-items: center;
      .ant-steps-item-title {
        font-family: Lato;
        font-style: normal;
        font-weight: bold;
        font-size: 20px;
        line-height: 24px;
        color: #a5a9c5;
        padding-left: 20px;
      }
      .ant-steps-item-icon {
        border: none !important;
        background: #fff;
        width: 50px;
        height: 50px;
        text-align: center;
        line-height: 55px;

        .ant-steps-icon {
          font-family: Lato;
          font-style: normal;
          font-weight: bold;
          font-size: 20px;
          color: #a5a9c5;
        }
      }
    }
  }
  .ant-steps-item-active {
    .ant-steps-item-icon {
      background: #4a60f4 !important;
      .ant-steps-icon {
        color: #ffffff !important;
      }
    }
    .ant-steps-item-title {
      color: #4a60f4 !important;
    }
  }
  @media (max-width: 768px) {
    .ant-steps {
      display: flex;
      flex-direction: column;
      .ant-steps-item {
        padding-left: 0 !important;
        margin-bottom: 10px;
      }
    }
  }
`;

export const VideoCardWrapper = styled.div`
  box-shadow: 0px 4px 25px 1px rgba(0, 0, 0, 0.25);
  border-top: 1px solid #d3d6eb;
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #fff;
`;
export const VideoCardTitle = styled.h2`
  font-family: Lato;
  font-style: normal;
  font-weight: 800;
  font-size: 30px;
  line-height: 36px;
  color: #2c304b;
`;
export const ErrorsCardWrapper = styled.div`
  select {
    padding: 2px 5px;
    cursor: pointer;
    border: none;
    font-family: Lato;
    font-style: normal;
    font-weight: normal;
    font-size: 18px;
    background: #ffecee;
    margin: 0 5px;
    color: #f20000;
    outline: none;
    -webkit-appearance: none;
    &::-ms-expand {
      display: none;
    }
  }
  .errors-card {
    border: 1px solid #d3d6eb;
    .ant-card-body {
      padding-bottom: 0;
      padding-right: 15px;
      padding-top: 30px;
      .card-inner {
        padding-top: 10px;
        padding-right: 15px;
        max-height: 370px;
        overflow-y: scroll;
        &::-webkit-scrollbar {
          width: 8px;
          background: #d3d6eb;
          border-radius: 20px;
        }

        &::-webkit-scrollbar-thumb {
          border-radius: 20px;
          -webkit-box-shadow: inset 0 0 3px red;
          background: #4a60f4;
        }
      }
    }
  }
  .errors-card2 {
    border: none !important;
    padding: 0;
    .ant-card-body {
      padding: 0;
      .card-inner2 {
        padding-right: 20px;
        padding-bottom: 100px;
        max-height: 75vh;
        overflow-y: scroll;
        &::-webkit-scrollbar {
          width: 8px;
          border-radius: 20px;
        }

        &::-webkit-scrollbar-track {
          width: 8px;
          background: #f9f9fc;
          border-radius: 20px;
        }

        &::-webkit-scrollbar-thumb {
          border-radius: 20px;
          background: #4a60f4;
        }
      }
    }
  }
`;
export const CardActions = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 0 -15px 0 -24px;
  border-top: 1px solid #d3d6eb;
  margin-top: 22px;
  position: relative;
  padding: 20px;
`;
export const ToolTip = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  padding: 10px;
  font-family: "Lato";
  color: #7c82a7;
`;
export const LeftActions = styled.div`
  display: flex;
  button {
    border: none;
    box-shadow: none;
    outline: none;
    padding: 0;
  }
  .right-btn {
    margin-left: 15px;
  }
`;
export const ErrorsCardTitle = styled.h2`
  font-family: Lato;
  font-style: normal;
  font-weight: bold;
  font-size: 20px;
  line-height: 24px;
  color: #2c304b;
  margin-bottom: 20px;
`;
export const ErrorText = styled.p`
  font-family: Lato;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 21px;
  color: #7c82a7;
`;

export const CardHeader = styled.div`
  display: flex;
  align-items: center;
  width: -webkit-fill-available;
  margin-left: 0px;
  margin-right: 0px;
  padding-bottom: 20px;
  flex-wrap: wrap;
  .right-wrapper {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    flex-wrap: wrap;
    width: 100%;
  }
  .arrows-wrapper {
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: space-between;

    button {
      border: none;
    }
    .export-btn {
      height: 40px;
      background: rgba(175, 186, 255, 0.2);
      font-family: Lato;
      font-style: normal;
      font-weight: bold;
      font-size: 17px;
      line-height: 24px;
      color: #4a60f4;
      padding-left: 30px;
      padding-right: 30px;
      .ant-image {
        margin-right: 10px;
      }
    }
    .copy-btn {
      font-family: Lato;
      font-style: normal;
      font-weight: 500;
      font-size: 20px;
      line-height: 24px;
      margin-right: 10px;
      color: #4a60f4;
      @media (max-width: 786px) {
        padding-left: 0;
      }
    }
  }
`;

export const InputWrapper = styled.div`
  position: relative;
  input {
    padding-left: 50px;
    height: 40px;
  }
  .ant-image {
    position: absolute;
    left: 15px;
    top: 8px;
    z-index: 1;
  }
`;

export const Quote = styled.div`
  position: relative;
  padding: 10px;
  padding-top: 25px;
  padding-bottom: 30px;
  width:100%;
  border-top: 1px solid lightgray;
  .quote {
    color: gray;
    font-size: 14px;
    line-height: 1.7;
  }
`;

export const CopyIconStyles = {
  position: "absolute",
  top: "7px",
  right: "5px",
  color: "lightgray",
  "font-size": "16px",
};
